import { render, staticRenderFns } from "./End.vue?vue&type=template&id=5d8f5348&scoped=true&"
var script = {}
import style0 from "./End.vue?vue&type=style&index=0&id=5d8f5348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8f5348",
  null
  
)

export default component.exports